import { formatClock, formatLongDate, greetingLine, spruchOfDay } from './greeting'
import { useLiveClock } from './useLiveClock'

/**
 * Kopf der Übersicht (für jede Rolle gleich): Tageszeit-Begrüßung mit Vorname, laufende Uhr (Sekundentakt)
 * + ausgeschriebenes Datum und der Spruch des Tages. Die Uhr kommt aus useLiveClock (räumt beim Unmount auf).
 */
export function GreetingHeader({ name }: { name: string }) {
  const now = useLiveClock()
  return (
    <header className="wf-greeting">
      <h2 className="wf-greeting__hello">{greetingLine(now, name)}</h2>
      <div className="wf-greeting__meta">
        <time className="wf-greeting__clock" aria-label="Aktuelle Uhrzeit">
          {formatClock(now)}
        </time>
        <span className="wf-greeting__date">{formatLongDate(now)}</span>
      </div>
      <p className="wf-greeting__spruch">{spruchOfDay(now)}</p>
    </header>
  )
}
